<template>
    <div class="h-screen w-full flex items-center justify-center">
        <div class="w-[55%] h-full overflow-hidden relative bg-[radial-gradient(circle_at_bottom,#000,#000_50%,#200D42_65%,#4F21A1_80%,#A46EDB_95%)]">
            <div class="p-[16px] mt-[16px] text-white font-normal text-center text-[20px]">
                Attendance - Payroll - HR Management System
            </div>
            <img src="@/assets/ui-img.png" alt="app image" class="h-[82vh] object-cover absolute bottom-16 translate-x-[30%] rounded-xl"/>
            <img src="@/assets/ui-img.png" alt="app image" class="h-[82vh] object-cover absolute bottom-0 translate-x-[10%] rounded-xl shadow-xl"/>
        </div>
        <div class="w-[45%] h-full flex items-center justify-center">
            <div class="p-6 rounded-lg w-[55%]">
                <div class="size-[40px] overflow-hidden mx-auto mb-4 rounded-xl bg-primary flex items-center justify-center text-white font-semibold">
                   <img src="@/assets/iu.jpg" alt="logo" class="h-[40px] w-[40px] object-contain"/>
                </div>
                <div class="text-center mb-1 text-[15px]">Bienvenue</div>
                <div class="font-extralight text-center text-[12px]">Veuillez entrer vos informations pour accéder au tableau de bord</div>
                <form id="sign_in" @submit.prevent="signin">
                            <div class="mb-2 mt-8 font-light">Identifiant/email</div>
                            <div class="h-[40px] w-full rounded-xl relative">
                                <input type="text" v-model="credentials.identifier" name="username" placeholder="Identifiant" class="h-full w-full rounded-xl pr-4 pl-16 border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground" >
                                <span class="h-full absolute left-0 top-0 flex items-center pl-4">
                                    <IdCard :size="18" strokeWidth="1.2"/>
                                </span>
                            </div>
                            <div class="mb-2 mt-4 font-light">Mot de passe</div>
                            <div class="h-[40px] w-full rounded-xl relative">
                                <input :type="show ? 'text' :'password'" v-model="credentials.password" name="password" placeholder="Entrer votre mot de passe" class="h-full w-full rounded-xl pl-4 pr-16 border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground" >
                                <span class="h-full absolute right-0 top-0 flex items-center pr-4 cursor-pointer" v-on:click="swithShow">
                                    <Eye v-if="show" :size="18" strokeWidth="1.2"/>
                                    <EyeClosed v-if="!show" :size="18" strokeWidth="1.2"/>
                                </span>
                            </div>

                            <div class="w-full flex justify-end my-6">
                                <RouterLink to="/reset-password" class="text-primary font-light">Mot de passe oublié?</RouterLink>
                            </div>

                            <button id="action" :disabled="loading" class="bg-primary font-light align-center h-[40px] w-full rounded-xl">
                                <Loader2 v-if="loading" class="animate-spin mx-auto"/>
                                <span v-if="!loading">Connexion</span>
                            </button>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Auth from "../../service/Auth.js";
import {Eye,EyeClosed,IdCard,Loader2} from "lucide-vue-next";
import { RouterLink } from 'vue-router';
import gsap from "gsap";
import Swal from 'sweetalert2';
export default {
    name: 'SigninView',
    components:{
        RouterLink,
        Eye,
        EyeClosed,
        IdCard,
        Loader2
    },
    data() {
        return {
            loading: false,
            show:false,
            credentials: { identifier: '', password: '' }
        }
    },
    methods: {
        switchLoader(){
            this.loading = !this.loading;
        },
        swithShow(){
            this.show = !this.show;
            // router.push({path:"/signin?show_password=true"});
        },
        signin() {
            gsap.to("#action",{scale:0.99,ease: "power1.out",duration:0.15,onComplete:()=>{
                gsap.to("#action",{scale:1,duration:0.3,ease:"back.out(1.7)"})
            }})
            if(!this.credentials.identifier || !this.credentials.password){
                return Swal.fire('Erreur!!!',"Veuillez remplir tous les champs",'error');
            }
            this.switchLoader()
            Auth.login(this.credentials,this.switchLoader);
        },
    },
}

</script>